import { isString } from "../types/isString";

const pattern =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

/**
 * Checks if the given value is a valid email address.
 *
 * This function uses a regular expression pattern to validate the email address format.
 * It first checks if the value is a string using the `isString` utility function.
 * If the value is not a string, it returns `false`.
 * If the value is a string, it converts it to lowercase and tests it against the email pattern.
 *
 * @param value - The value to be checked.
 * @returns `true` if the value is a valid email address, `false` otherwise.
 */
export const isValidEmail = (value: unknown): boolean => {
  if (!isString(value)) {
    return false;
  }
  return pattern.test(value.toLowerCase());
};
